import React, { useState } from "react";
import logo from "../../assets/logo_ciano_50_bianco.png";
import toastStyles from "../../styles/Toast.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Importazione di FontAwesomeIcon
import { faSignOutAlt, faArrowLeft } from "@fortawesome/free-solid-svg-icons"; // Importazione delle icone
import { HiArrowSmLeft } from "react-icons/hi";
import { AiOutlineLogout } from "react-icons/ai";
import "../../styles/Menu.css";
import { useNavigate } from "react-router-dom";
import Menu from "./Menu";

function PreviousPage() {
  const navigate = useNavigate();

  // Funzione di logout
  const onLogOut = () => {
    localStorage.removeItem("AuthToken");
    navigate("/entry");
  };

  return (
    <div className="Menu">
      <div>
        <button
          type="button"
          onClick={() => window.history.back()}
          title="Previous Page"
        >
          <HiArrowSmLeft style={{ color: "white", fontSize: "24px" }} />
        </button>
      </div>
      <div className={toastStyles.menu}>
        <img src={logo} alt="" className={toastStyles.responsiveImage} />
        finstagram
      </div>
      <div className="logout">
        <button type="button" onClick={() => onLogOut()}>
          <AiOutlineLogout style={{ color: "white", fontSize: "24px" }} />
        </button>
      </div>
    </div>
  );
}

export default PreviousPage;
